declare var __webpack_nonce__: string;
__webpack_nonce__ = (<any> window).ScriptNonce;

const nonce = (<any> window).ScriptNonce;

// Create Trusted Types policies for client-side DOM manipulation.
// The view inline script may have already created these, so check before creating
// to avoid CSP violations (duplicate policy creation is blocked even with try/catch).
if ((<any> window).trustedTypes && (<any> window).trustedTypes.createPolicy) {
  if (!(<any> window).__ucisPolicyCreated) {
    try {
      (<any> window).trustedTypes.createPolicy("ucis", {
        createHTML: (input: string) => input,
        createScript: (input: string) => input,
        createScriptURL: (input: string) => input,
      });
      (<any> window).__ucisPolicyCreated = true;
    } catch (e) {
      // Policy 'ucis' may already exist
    }
  }
  if (!(<any> window).trustedTypes.defaultPolicy) {
    try {
      (<any> window).trustedTypes.createPolicy("default", {
        createHTML: (input: string) => input,
        createScript: (input: string) => input,
        createScriptURL: (input: string) => input,
      });
    } catch (e) {
      // Policy 'default' may already exist
    }
  }
}

// Configure Fluent UI mergeStyles CSP settings BEFORE any FluentUI imports
// This must be set before mergeStyles creates any style tags
(<any> window).FabricConfig = (<any> window).FabricConfig || {};
(<any> window).FabricConfig.mergeStyles = {
  ...(<any> window).FabricConfig.mergeStyles,
  cspSettings: { nonce }
};

// Also configure mergeStyles directly if it's already loaded
try {
  const { Stylesheet } = require("@fluentui/merge-styles");
  if (Stylesheet && Stylesheet.getInstance) {
    Stylesheet.getInstance().setConfig({ cspSettings: { nonce } });
  }
} catch (e) {
  // mergeStyles not loaded yet, FabricConfig will handle it
}
